export const hashDashboardSections = async (objectList: string[]): Promise<string> => {
  const sortedList = [...objectList].sort();

  const dataUint8 = new TextEncoder().encode(JSON.stringify(sortedList));
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', dataUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  return hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
    .slice(0, 22)
    .padStart(22, '0');
};
